import { lazy, Suspense } from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import { AuthProvider } from './contexts/AuthContext'
import { LanguageProvider } from './contexts/LanguageContext'
import { CVProvider } from './hooks/useCV'
import { LocalCVListProvider } from './hooks/useLocalCVList'
import { Header } from './components/layout/Header'
import { SinglePageApp } from './pages/SinglePageApp'

// Lazy-loaded pages
const LandingPage = lazy(() => import('./pages/LandingPage'))
const PublicCVPage = lazy(() => import('./pages/PublicCVPage'))
const AdminPage = lazy(() => import('./pages/AdminPage'))
const PrivacyPage = lazy(() => import('./pages/PrivacyPage'))
const TermsPage = lazy(() => import('./pages/TermsPage'))
const NotFoundPage = lazy(() => import('./pages/NotFoundPage'))

function EditorLayout() {
  return (
    <LocalCVListProvider>
      <CVProvider>
        <div className="h-screen h-[100dvh] flex flex-col bg-background overflow-hidden">
          <Header />
          <main className="flex-1 min-h-0 overflow-hidden">
            <SinglePageApp />
          </main>
        </div>
      </CVProvider>
    </LocalCVListProvider>
  )
}

function App() {
  return (
    <LanguageProvider>
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route
            path="/"
            element={
              <Suspense fallback={<div className="h-screen" />}>
                <LandingPage />
              </Suspense>
            }
          />
          <Route path="/builder" element={<EditorLayout />} />
          <Route
            path="/admin"
            element={
              <Suspense fallback={<div className="h-screen bg-[#0A0A0B]" />}>
                <AdminPage />
              </Suspense>
            }
          />
          <Route
            path="/cv/:slug"
            element={
              <Suspense fallback={<div className="h-screen flex items-center justify-center"><div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin" /></div>}>
                <PublicCVPage />
              </Suspense>
            }
          />
          <Route
            path="/privacy"
            element={
              <Suspense fallback={<div className="h-screen" />}>
                <PrivacyPage />
              </Suspense>
            }
          />
          <Route
            path="/terms"
            element={
              <Suspense fallback={<div className="h-screen" />}>
                <TermsPage />
              </Suspense>
            }
          />
          <Route
            path="*"
            element={
              <Suspense fallback={null}>
                <NotFoundPage />
              </Suspense>
            }
          />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: '#1F1F1F',
            color: '#fff',
            borderRadius: '12px',
            padding: '12px 16px',
          },
          success: {
            iconTheme: {
              primary: '#10B981',
              secondary: '#fff',
            },
          },
          error: {
            iconTheme: {
              primary: '#EF4444',
              secondary: '#fff',
            },
          },
        }}
      />
    </AuthProvider>
    </LanguageProvider>
  )
}

export default App
